'use strict';

const errorSvg = require('../images/error.svg');

angular.module('docketbook').
controller('mainTemplateController', function() {
  $scope.errorSvgImagePath = errorSvg;
})


// WEBPACK FOOTER //
// ./src/controllers/mainTemplateController.js